import { isPhoneLikeViewport } from "@/utils/ViewportClassification";
import { readViewportSignals } from "@/utils/readViewportSignals";
import type { Platform } from "./Platform";

/**
 * PR34: reads the live viewport ONCE and classifies it with the game's
 * existing phone-like rule (`isPhoneLikeViewport()` - the same check the
 * orientation gate uses), never a new heuristic: no user-agent sniffing, no
 * input-device counting. Callers call this once per run (at `GameScene`
 * start) or once per leaderboard screen and keep the answer - a run's
 * platform never changes mid-run.
 */
export function detectPlatform(): Platform {
  return isPhoneLikeViewport(readViewportSignals()) ? "mobile" : "desktop";
}
